import React, { useMemo } from "react";

import { Parking } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../LightTable";
import { TaxiServicesByIds } from "../../../../../../common";

const TaxiServiceCellContent: React.FC<TaxiServiceCellContent.Props> = ({
	item,
}) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(
		() => item.taxiServiceId ?? "",
		[item.taxiServiceId],
	);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="6px"
			cursor="pointer"
		>
			<TaxiServicesByIds taxiServiceIds={[content]} lang={lang} />
		</CellContentRoot>
	);
};

declare namespace TaxiServiceCellContent {
	interface Props {
		item: Parking.Model;
	}
}

export default TaxiServiceCellContent;
